var render = function render(){var _vm=this,_c=_vm._self._c;return _c('global-footer',{staticClass:"footer custom-render",scopedSlots:_vm._u([{key:"links",fn:function(){return undefined},proxy:true},{key:"copyright",fn:function(){return [_vm._v(" Copyright © 2023 "),_c('a',{attrs:{"href":"http://www.jeequan.com","target":"_blank"}},[_vm._v("jeequan.com")]),_vm._v(". All rights reserved. ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }